"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("react/jsx-runtime");
const styled_components_1 = __importDefault(require("styled-components"));
const styles_1 = require("@mui/material/styles");
const ToggleButton_1 = __importDefault(require("@mui/material/ToggleButton"));
const uniqueId_1 = __importDefault(require("lodash/uniqueId"));
const Radio_1 = __importDefault(require("../Radio"));
const Checkbox_1 = __importDefault(require("../Checkbox"));
const StyledToggleButton = (0, styled_components_1.default)(ToggleButton_1.default) `
  label {
    color: ${({ theme }) => theme.palette.text.primary};
    text-transform: none;
    pointer-events: none;
    font-size: 18px;
    text-align: left;
    line-height: 1.2;
  }
  label > p {
    font-size: 16px;
    color: ${({ theme }) => theme.palette.gray[50]};
  }

  .MuiCheckbox-root,
  .MuiRadio-root {
    margin-right: 3px;
  }

  &.MuiToggleButton-root {
    justify-content: flex-start;
    margin-bottom: 13px;
    margin-top: 0 !important;
    &:last-child {
      margin-bottom: 0;
    }
    background-color: ${({ theme }) => theme.palette.gray[0]};
    border: 1px solid transparent;
    border-radius: 4px !important;
    padding: 8px 15px;

    @media (min-width: ${({ theme }) => theme.breakpoints.md}px) {
      padding: 5px 15px;
    }

    &:hover: {
      background-color: ${({ theme }) => theme.palette.teal[0]};
    }
    &.Mui-focusVisible {
      box-shadow: ${({ theme }) => `0 0 10px 0 ${theme.palette.primary.main}, 0 0 5px 0 ${theme.palette.primary.main}`};
    }
    &.Mui-selected {
      background-color: ${({ theme }) => theme.palette.teal[0]};
      color: ${({ theme }) => theme.palette.primary.main};
      border-color: ${({ theme }) => theme.palette.primary.main};
      &:hover: {
        background-color: ${({ theme }) => theme.palette.teal[10]};
      }
      &,
      & + .MuiToggleButton-root.Mui-selected {
        border: ${({ theme }) => `1px solid ${theme.palette.primary.main}`};
      }
    }
    &[data-error="true"] {
      border-color: ${({ theme }) => `${theme.palette.status.error} !important`};
    }
  }
`;
/** A selectable button that can display either a checkbox or radio */
function ToggleButton({ hasError, label, multiSelect, value, selected, subText, ...rest }) {
    const theme = (0, styles_1.useTheme)();
    const Control = multiSelect ? Checkbox_1.default : Radio_1.default;
    const id = (0, uniqueId_1.default)();
    const checkedIconProps = { color: theme.palette.primary.main };
    return ((0, jsx_runtime_1.jsxs)(StyledToggleButton, { "aria-label": label, "data-error": !!hasError, disableFocusRipple: true, id: id, selected: selected, value: value, ...rest, children: [(0, jsx_runtime_1.jsx)(Control, { "aria-hidden": true, checked: selected, checkedIconProps: checkedIconProps, disabled: true, edge: "start" }), (0, jsx_runtime_1.jsxs)("label", { htmlFor: id, children: [label, subText && (0, jsx_runtime_1.jsx)("p", { className: "", children: subText })] })] }));
}
exports.default = ToggleButton;
//# sourceMappingURL=index.js.map